/**
 * loadingDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function loadingDirective() {
    return {
        // language=HTML
        template: `
            <div class="app-loading-inner">
                <md-progress-circular md-mode="indeterminate"
                                      md-diameter="{{ diameter || 40 }}">
                </md-progress-circular>
            </div>
        `,
        scope: {
            diameter: '=?diameter',
        },
        compile: function compile() {
            return {
                pre: function preLink(scope, element, attrs) {
                    if (scope.diameter === undefined && attrs.small !== undefined) {
                        scope.diameter = 24;
                    }
                },
            };
        },
    };
}
